import curry from "./curry.js";

export default curry(function multiply(a, b) {
  return a * b;
});